module.exports = __webpack_public_path__ + "static/media/eight-ball.79702a8b.png";